import { render } from "./PrescriptionProtocol.vue?vue&type=template&id=dfd7155c"
import script from "./PrescriptionProtocol.vue?vue&type=script&lang=js"
export * from "./PrescriptionProtocol.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__